import styled from 'styled-components';

export const PortfolioShowcaseWrapper = styled.div`
  @keyframes FadeInUp {
    from {
      opacity: 0;
      transform: translateY(30px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .glide__controls {
    position: absolute;
    bottom: -12px;
    right: 0;
    @media (max-width: 990px) {
      bottom: 23px;
    }
    @media (max-width: 575px) {
      top: -50px;
      right: 50%;
      bottom: auto;
      transform: translateX(50%);
    }
  }

  .rc-tabs-bar {
    border: none !important;
    margin-bottom: 80px;
    @media (max-width: 990px) {
      margin-bottom: 45px;
    }
    @media (max-width: 575px) {
      margin-bottom: 65px;
    }
    &:focus,
    *:focus {
      outline: none;
    }
    .rc-tabs-nav-scroll {
      .rc-tabs-nav {
        .rc-tabs-tab {
          font-size: 16px;
          font-weight: 700;
          font-family: 'Lato', sans-serif;
          color: #000004;
          display: inline-block;
          margin-right: 40px;
          cursor: pointer;
          @media (max-width: 990px) {
            font-size: 15px;
            margin-right: 35px;
            padding-bottom: 20px;
          }
          @media (max-width: 575px) {
            margin-right: 20px;
            font-size: 14px;
          }
          &:last-child {
            margin-right: 0;
          }
          &.rc-tabs-tab-active {
            > span {
              &:before {
                width: 100%;
              }
            }
          }
          &:hover {
            > span {
              &:before {
                width: 100%;
              }
            }
          }
          > span {
            position: relative;
            display: block;
            margin: 0;
            overflow: hidden;
            &:before {
              content: attr(data-text);
              position: absolute;
              top: 0;
              left: 0;
              width: 0;
              color: #4b50b2;
              overflow: hidden;
              white-space: nowrap;
              transition: 0.5s ease-in-out;
            }
          }
        }
      }
    }
  }

  .rc-tabs-content {
    .rc-tabs-tabpane {
      display: none;
      overflow: initial;

      &.rc-tabs-tabpane-active {
        display: block;
        animation: 0.7s FadeInUp;
      }
    }
  }

  .rc-tabs-ink-bar {
    display: none !important;
  }

  .rc-tabs-top {
    border: none;
  }
`;

export const PortfolioShowcaseItem = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
`;

export const PortfolioLink = styled.div`
  margin-bottom: 36px;
  @media (max-width: 990px) {
    margin-bottom: 25px;
  }
  @media (max-width: 575px) {
    margin-bottom: 15px;
  }
  a {
    font-size: 16px;
    font-weight: 700;
    font-family: 'Lato', sans-serif;
    color: #000004;
    position: relative;
    padding: 0 0 2px 8px;
    @media (max-width: 990px) {
      font-size: 15px;
    }
    @media (max-width: 575px) {
      font-size: 14px;
    }
    &:before,
    &:after {
      content: '';
      display: block;
      width: 58px;
      height: 15px;
      position: absolute;
      background: #eaecfe;
      bottom: 0;
      left: 0;
      z-index: -1;
    }
    &:after {
      background: #4b50b2;
      transform: scaleX(0);
      transform-origin: right center 0;
      transition: transform 0.7s cubic-bezier(0.19, 1, 0.22, 1) 0s;
    }
    &:hover {
      &:after {
        transform: scaleX(1);
        transform-origin: left center 0;
        transition: transform 0.35s cubic-bezier(0.43, 0.49, 0.51, 0.68);
      }
    }
  }
`;

export const BuiltWith = styled.div`
  margin-top: 60px;
  @media (max-width: 990px) {
    margin-top: 30px;
  }
  > span {
    display: inline-block;
    font-size: 16px;
    font-weight: 600;
    color: #3444f1;
    font-family: 'Lato', sans-serif;
    padding: 5px 22px;
    position: relative;
    @media (max-width: 990px) {
      font-size: 14px;
      padding: 5px 10px;
    }
    &:first-child {
      padding-left: 0;
    }
    &:last-child {
      padding-right: 0;
      &:after {
        display: none;
      }
    }
    &:after {
      content: '|';
      position: absolute;
      display: block;
      top: 50%;
      right: 0;
      transform: translateY(-50%);
    }
  }
`;

export const PortfolioMeta = styled.div`
  flex: 0 0 100%;
  max-width: calc(100% - 200px);
  margin-top: 70px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  @media (max-width: 990px) {
    margin-top: 50px;
    max-width: calc(100% - 100px);
  }
  @media (max-width: 575px) {
    margin-top: 30px;
    max-width: 100%;
    margin-bottom: 15px;
  }
`;

